<div class="h-full flex flex-col justify-start items-center overflow-hidden space-y-2">
    @if (manageBriefTabsService.focussedBrief()) {

    @if (!isLoading() && shipments().length === 0) {
    <!-- Empty state: no product shipments yet -->
    <div class="w-full h-full flex items-center justify-center overflow-y-auto px-4 py-8 sm:px-8">
        <div class="w-full max-w-3xl">
            <div
                class="rounded-2xl border border-zinc-200 bg-linear-to-b from-sky-500/5 to-transparent p-6 sm:p-10 dark:border-zinc-800 dark:from-sky-400/10">
                <div class="text-center">
                    <span
                        class="inline-flex items-center gap-1.5 rounded-full bg-sky-50 px-3 py-1 text-xs font-medium text-sky-800 ring-1 ring-inset ring-sky-600/20 dark:bg-sky-500/10 dark:text-sky-300 dark:ring-sky-500/20">
                        <span class="size-1.5 rounded-full bg-sky-500 animate-pulse" aria-hidden="true"></span>
                        Waiting for shipments
                    </span>

                    <div class="relative mx-auto mt-6 flex size-20 items-center justify-center">
                        <div class="absolute inset-0 rounded-full bg-sky-500/10 dark:bg-sky-400/15" aria-hidden="true">
                        </div>
                        <div class="absolute inset-2 rounded-full bg-sky-500/5 dark:bg-sky-400/10" aria-hidden="true">
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="relative size-9 text-sky-600 dark:text-sky-400" aria-hidden="true">
                            <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" />
                            <path d="M15 18H9" />
                            <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" />
                            <circle cx="17" cy="18" r="2" />
                            <circle cx="7" cy="18" r="2" />
                        </svg>
                    </div>

                    <h2 class="mt-6 text-2xl font-semibold text-primary use-grotesque">Brief Logistics</h2>
                    <p class="mx-auto mt-3 max-w-lg text-sm leading-6 text-secondary sm:text-base">
                        Once product shipments are created for hired creators, you can track delivery status, carriers,
                        and tracking numbers from here.
                    </p>
                </div>

                <p class="mt-8 text-center text-xs font-semibold uppercase tracking-wide text-secondary">
                    What you'll see here
                </p>

                <ul role="list" class="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4">
                    <li
                        class="flex gap-3 rounded-xl border border-zinc-200 bg-white/70 p-4 text-left dark:border-zinc-800 dark:bg-zinc-900/50">
                        <div
                            class="flex size-10 shrink-0 items-center justify-center rounded-lg bg-sky-500/10 dark:bg-sky-400/15">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-sky-600 dark:text-sky-400" aria-hidden="true">
                                <path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" />
                                <path d="M12 22V12" />
                                <polyline points="3.29 7 12 12 20.71 7" />
                                <path d="m7.5 4.27 9 5.15" />
                            </svg>
                        </div>
                        <div>
                            <h3 class="text-sm font-semibold text-primary">Shipment Status</h3>
                            <p class="mt-1 text-xs leading-5 text-secondary">
                                Track each creator from not shipped through to delivered.
                            </p>
                        </div>
                    </li>
                    <li
                        class="flex gap-3 rounded-xl border border-zinc-200 bg-white/70 p-4 text-left dark:border-zinc-800 dark:bg-zinc-900/50">
                        <div
                            class="flex size-10 shrink-0 items-center justify-center rounded-lg bg-sky-500/10 dark:bg-sky-400/15">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-sky-600 dark:text-sky-400" aria-hidden="true">
                            <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" />
                            <path d="M15 18H9" />
                            <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" />
                            <circle cx="17" cy="18" r="2" />
                            <circle cx="7" cy="18" r="2" />
                            </svg>
                        </div>
                        <div>
                            <h3 class="text-sm font-semibold text-primary">Carrier Assignment</h3>
                            <p class="mt-1 text-xs leading-5 text-secondary">
                                Assign DHL, UPS, Royal Mail, and other carriers per shipment.
                            </p>
                        </div>
                    </li>
                    <li
                        class="flex gap-3 rounded-xl border border-zinc-200 bg-white/70 p-4 text-left dark:border-zinc-800 dark:bg-zinc-900/50">
                        <div
                            class="flex size-10 shrink-0 items-center justify-center rounded-lg bg-sky-500/10 dark:bg-sky-400/15">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-sky-600 dark:text-sky-400" aria-hidden="true">
                                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                                <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
                            </svg>
                        </div>
                        <div>
                            <h3 class="text-sm font-semibold text-primary">Tracking Numbers</h3>
                            <p class="mt-1 text-xs leading-5 text-secondary">
                                Add tracking codes and open carrier tracking pages in one place.
                            </p>
                        </div>
                    </li>
                    <li
                        class="flex gap-3 rounded-xl border border-zinc-200 bg-white/70 p-4 text-left dark:border-zinc-800 dark:bg-zinc-900/50">
                        <div
                            class="flex size-10 shrink-0 items-center justify-center rounded-lg bg-sky-500/10 dark:bg-sky-400/15">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-sky-600 dark:text-sky-400" aria-hidden="true">
                                <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                                <circle cx="12" cy="10" r="3" />
                            </svg>
                        </div>
                        <div>
                            <h3 class="text-sm font-semibold text-primary">Creator Addresses</h3>
                            <p class="mt-1 text-xs leading-5 text-secondary">
                                Copy delivery addresses and see shipped and delivered dates.
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    } @else {

    <!-- Status menu overlay — closes pill menu when clicking outside -->
    @if (statusMenuOpenId()) {
    <div class="fixed inset-0 z-40" (click)="closeStatusMenu()" aria-hidden="true"></div>
    }
    <!-- Carrier menu overlay — closes carrier dropdown when clicking outside -->
    @if (carrierMenuOpenId()) {
    <div class="fixed inset-0 z-40" (click)="closeCarrierMenu()" aria-hidden="true"></div>
    }

    <!-- Header: search + filter chips -->
    <div class="flex-0 flex flex-row items-center justify-between w-full border-b border-zinc-200 dark:border-zinc-800 pb-2 gap-x-4 flex-wrap gap-y-2">
        <div class="flex flex-row items-center gap-x-2 flex-1 min-w-48">
            <div class="grid grid-cols-1">
                <input [formField]="searchQueryForm.query" id="logistics-search" type="text"
                    placeholder="Search by creator name" class="input-icon text-primary" />
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-500 sm:size-4">
                    <path d="m21 21-4.34-4.34" />
                    <circle cx="11" cy="11" r="8" />
                </svg>
            </div>
        </div>

        <!-- Filter tabs (styling aligned with Assignment tab status filters) -->
        <div class="">
            <div class="hidden sm:block">
                <nav aria-label="Shipment status filter" class="flex space-x-1">
                    <button type="button"
                        class="rounded-md px-2 py-2 text-xs font-medium cursor-pointer flex flex-row items-center justify-center gap-x-1 border-0"
                        [class]="getShipmentFilterButtonClass(null)"
                        (click)="setStatusFilter(null)">
                        All
                        <span class="text-xs text-secondary">({{ shipments().length }})</span>
                    </button>
                    <button type="button"
                        class="rounded-md px-2 py-2 text-xs font-medium cursor-pointer flex flex-row items-center justify-center gap-x-1 border-0"
                        [class]="getShipmentFilterButtonClass('Not-Shipped')"
                        (click)="setStatusFilter('Not-Shipped')">
                        Not Shipped
                        <span class="text-xs text-secondary">({{ statusCounts()['Not-Shipped'] }})</span>
                    </button>
                    <button type="button"
                        class="rounded-md px-2 py-2 text-xs font-medium cursor-pointer flex flex-row items-center justify-center gap-x-1 border-0"
                        [class]="getShipmentFilterButtonClass('Shipped')"
                        (click)="setStatusFilter('Shipped')">
                        Shipped
                        <span class="text-xs text-secondary">({{ statusCounts()['Shipped'] }})</span>
                    </button>
                    <button type="button"
                        class="rounded-md px-2 py-2 text-xs font-medium cursor-pointer flex flex-row items-center justify-center gap-x-1 border-0"
                        [class]="getShipmentFilterButtonClass('Delivered')"
                        (click)="setStatusFilter('Delivered')">
                        Delivered
                        <span class="text-xs text-secondary">({{ statusCounts()['Delivered'] }})</span>
                    </button>
                </nav>
            </div>
        </div>
    </div>

    <!-- Bulk action bar -->
    @if (selected().size > 0) {
    <div class="w-full flex-0">
        <div class="bulk-bar">
            <span class="bulk-count">{{ selected().size }}</span>
            <p class="m-0 text-white/60 text-sm mr-1">selected</p>
            @if (bulkSaving()) {
            <svg aria-hidden="true" class="w-4 h-4 text-white/40 animate-spin fill-white" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
            </svg>
            } @else {
            <button type="button" class="bulk-action-btn" (click)="bulkMark('Shipped')">Mark as Shipped</button>
            <button type="button" class="bulk-action-btn" (click)="bulkMark('Delivered')">Mark as Delivered</button>
            }
            <button type="button" class="bulk-clear-btn ml-auto" (click)="clearSelection()" aria-label="Clear selection">×</button>
        </div>
    </div>
    }

    <!-- Main Content -->
    <div class="h-full flex-1 flex-col items-center justify-center w-full overflow-hidden">

        @if (isLoading()) {
        <!-- Skeleton -->
        <div class="w-full h-full flex flex-col overflow-hidden">
            <div class="flow-root flex-1 min-h-0 overflow-hidden">
                <div class="overflow-x-auto h-full">
                    <div class="inline-block min-w-full align-middle h-full">
                        <div class="data-table-wrapper h-full flex flex-col overflow-hidden">
                            <div class="overflow-y-auto flex-1 min-h-0 scrollbar-hide">
                                <table class="data-table min-w-full">
                                    <thead class="sticky top-0 z-10">
                                        <tr>
                                            <th scope="col" class="w-10"></th>
                                            <th scope="col" class="text-left text-sm font-semibold">Creator</th>
                                            <th scope="col" class="text-left text-sm font-semibold">Shipping Address</th>
                                            <th scope="col" class="text-left text-sm font-semibold">Status</th>
                                            <th scope="col" class="text-left text-sm font-semibold">Carrier</th>
                                            <th scope="col" class="text-left text-sm font-semibold">Tracking</th>
                                            <th scope="col" class="text-left text-sm font-semibold">Dates</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (sk of [1,2,3,4,5,6]; track sk) {
                                        <tr class="border-b border-zinc-100 dark:border-zinc-800">
                                            <td class="py-3"><div class="w-4 h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse mx-auto"></div></td>
                                            <td class="py-3">
                                                <div class="flex items-center gap-x-3">
                                                    <div class="size-10 rounded-full bg-gray-200 dark:bg-gray-700 animate-pulse shrink-0"></div>
                                                    <div class="flex flex-col gap-y-1">
                                                        <div class="h-3.5 w-28 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
                                                        <div class="h-2.5 w-20 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="py-3">
                                                <div class="flex flex-col gap-y-1">
                                                    <div class="h-3 w-36 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
                                                    <div class="h-2.5 w-24 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
                                                </div>
                                            </td>
                                            <td class="py-3"><div class="h-8 w-28 bg-gray-200 dark:bg-gray-700 rounded-full animate-pulse"></div></td>
                                            <td class="py-3"><div class="h-4 w-20 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div></td>
                                            <td class="py-3"><div class="h-7 w-32 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div></td>
                                            <td class="py-3"><div class="h-3 w-20 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div></td>
                                        </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        } @else if (displayedShipments().length === 0) {
        <!-- Filter empty state -->
        <div class="w-full h-full flex items-center justify-center p-8">
            <div class="max-w-md text-center">
                <div class="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-sky-500/10 dark:bg-sky-400/15 mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-8 text-sky-600 dark:text-sky-400" aria-hidden="true">
                        <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" />
                        <path d="M15 18H9" />
                        <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" />
                        <circle cx="17" cy="18" r="2" />
                        <circle cx="7" cy="18" r="2" />
                    </svg>
                </div>
                <h2 class="text-xl font-semibold text-primary mb-2">No Shipments Found</h2>
                <p class="text-sm text-secondary">
                    No shipments match the selected status. Try a different filter.
                </p>
            </div>
        </div>

        } @else {
        <!-- Table -->
        <div class="w-full h-full flex flex-col overflow-hidden">
            <div class="flow-root flex-1 min-h-0 overflow-hidden">
                <div class="overflow-x-auto h-full">
                    <div class="inline-block min-w-full align-middle h-full">
                        <div class="data-table-wrapper h-full flex flex-col overflow-hidden">
                            <div class="overflow-y-auto flex-1 min-h-0 scrollbar-hide dark:bg-gray-800/50">
                                <table class="data-table min-w-full">
                                    <thead class="sticky top-0 z-10">
                                        <tr>
                                            <!-- Master checkbox -->
                                            <th scope="col" class="w-10 px-3 py-3">
                                                <button type="button"
                                                    class="logi-checkbox"
                                                    [class.checked]="allSelected()"
                                                    [class.indeterminate]="someSelected()"
                                                    (click)="toggleAll()"
                                                    [attr.aria-checked]="someSelected() ? 'mixed' : allSelected()"
                                                    role="checkbox" aria-label="Select all">
                                                    @if (allSelected()) {
                                                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
                                                    } @else if (someSelected()) {
                                                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/></svg>
                                                    }
                                                </button>
                                            </th>
                                            <th scope="col" class="text-left text-sm font-semibold py-3 pr-3">Creator</th>
                                            <th scope="col" class="text-left text-sm font-semibold py-3 pr-3">Shipping Address</th>
                                            <th scope="col" class="text-left text-sm font-semibold py-3 pr-3">Status</th>
                                            <th scope="col" class="text-left text-sm font-semibold py-3 pr-3">Carrier</th>
                                            <th scope="col" class="text-left text-sm font-semibold py-3 pr-3">Tracking</th>
                                            <th scope="col" class="text-left text-sm font-semibold py-3 pr-3">Dates</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (shipment of displayedShipments(); track shipment.id) {
                                        <tr class="logi-row"
                                            [class.selected]="selected().has(shipment.id)"
                                            [class.logi-highlight]="highlightedShipmentId() === shipment.id"
                                            [id]="'logi-row-' + shipment.id">

                                            <!-- Row checkbox -->
                                            <td class="px-3 py-3 align-middle">
                                                <button type="button"
                                                    class="logi-checkbox"
                                                    [class.checked]="selected().has(shipment.id)"
                                                    (click)="toggleSelect(shipment.id)"
                                                    role="checkbox"
                                                    [attr.aria-checked]="selected().has(shipment.id)"
                                                    [attr.aria-label]="'Select ' + creatorName(shipment)">
                                                    @if (selected().has(shipment.id)) {
                                                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
                                                    }
                                                </button>
                                            </td>

                                            <!-- Creator -->
                                            <td class="py-3 pr-4 align-middle whitespace-nowrap">
                                                <div class="flex items-center gap-x-3">
                                                    @if (creatorPhoto(shipment)) {
                                                    <img [src]="imageService.getImageSource(creatorPhoto(shipment), 'gallery')" [alt]="creatorName(shipment)"
                                                        class="size-10 rounded-full object-cover shrink-0" />
                                                    } @else {
                                                    <span class="size-10 rounded-full flex items-center justify-center text-white text-sm font-bold shrink-0 select-none"
                                                        [style.background]="creatorAvatarGradient(shipment)">
                                                        {{ creatorInitials(shipment) }}
                                                    </span>
                                                    }
                                                    <div class="flex flex-col">
                                                        <span class="text-sm font-bold text-primary leading-tight">{{ creatorName(shipment) }}</span>
                                                        @if (creatorHandle(shipment)) {
                                                        <p class="m-0 text-xs text-secondary font-medium">{{ creatorHandle(shipment) }}</p>
                                                        }
                                                    </div>
                                                </div>
                                            </td>

                                            <!-- Shipping address -->
                                            <td class="py-3 pr-4 align-middle">
                                                @if (creatorAddress(shipment); as addr) {
                                                <div class="flex flex-row items-center justify-between gap-x-2">
                                                    <div class="flex flex-col flex-1">
                                                        <span class="addr-street">{{ addr.addressLine2 || addr.addressLine1 }}</span>
                                                        <span class="addr-meta">{{ addr.town }} · {{ addr.country }}</span>
                                                    </div>
                                                    <button type="button"
                                                        class="tracking-btn shrink-0"
                                                        [class.copied]="copiedAddressId() === shipment.id"
                                                        (click)="copyAddress(shipment)"
                                                        title="Copy full address">
                                                        @if (copiedAddressId() === shipment.id) {
                                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
                                                        } @else {
                                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/></svg>
                                                        }
                                                    </button>
                                                </div>
                                                } @else {
                                                <p class="m-0 text-xs text-secondary italic">No address saved</p>
                                                }
                                            </td>

                                            <!-- Status pill dropdown -->
                                            <td class="py-3 pr-4 align-middle">
                                                <div class="relative inline-block">
                                                    <button type="button"
                                                        [class]="pillClass(shipment.status)"
                                                        (click)="openStatusMenu(shipment.id)"
                                                        [attr.aria-expanded]="statusMenuOpenId() === shipment.id"
                                                        aria-haspopup="listbox">
                                                        <span [class]="dotClass(shipment.status)"></span>
                                                        <span>{{ pillLabel(shipment.status) }}</span>
                                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>
                                                    </button>
                                                    @if (statusMenuOpenId() === shipment.id) {
                                                    <div class="status-menu" role="listbox">
                                                        @for (opt of statusOptions; track opt) {
                                                        <button type="button"
                                                            role="option"
                                                            class="status-menu-item"
                                                            [class.active]="shipment.status === opt"
                                                            [attr.aria-selected]="shipment.status === opt"
                                                            (click)="changeStatus(shipment, opt)">
                                                            <span [class]="dotClass(opt)"></span>
                                                            {{ pillLabel(opt) }}
                                                        </button>
                                                        }
                                                    </div>
                                                    }
                                                </div>
                                            </td>

                                            <!-- Carrier -->
                                            <td class="py-3 pr-4 align-middle whitespace-nowrap">
                                                <div class="relative inline-block">
                                                    @if (carrierConfig(shipment.carrier); as c) {
                                                    <button type="button"
                                                        class="flex items-center gap-x-2 cursor-pointer hover:opacity-75 transition-opacity"
                                                        (click)="openCarrierMenu(shipment.id)"
                                                        title="Change carrier"
                                                        aria-haspopup="listbox"
                                                        [attr.aria-expanded]="carrierMenuOpenId() === shipment.id">
                                                        <span class="carrier-chip" [style.background]="c.bg" [style.color]="c.fg">{{ c.short }}</span>
                                                        <span class="text-sm text-secondary">{{ c.name }}</span>
                                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="text-secondary"><path d="m6 9 6 6 6-6"/></svg>
                                                    </button>
                                                    } @else {
                                                    <button type="button"
                                                        class="tracking-empty"
                                                        (click)="openCarrierMenu(shipment.id)"
                                                        aria-haspopup="listbox"
                                                        [attr.aria-expanded]="carrierMenuOpenId() === shipment.id">
                                                        Assign carrier
                                                    </button>
                                                    }
                                                    @if (carrierMenuOpenId() === shipment.id) {
                                                    <div class="status-menu carrier-menu" role="listbox" aria-label="Select carrier">
                                                        @for (key of carrierKeys; track key) {
                                                        <button type="button"
                                                            role="option"
                                                            class="status-menu-item"
                                                            [class.active]="shipment.carrier === key"
                                                            [attr.aria-selected]="shipment.carrier === key"
                                                            (click)="selectCarrier(shipment, key)">
                                                            <span class="carrier-chip carrier-chip-menu"
                                                                [style.background]="carriers[key].bg"
                                                                [style.color]="carriers[key].fg">
                                                                {{ carriers[key].short }}
                                                            </span>
                                                            {{ carriers[key].name }}
                                                        </button>
                                                        }
                                                        <div class="border-t border-[var(--border)] mt-1 pt-2 px-2 pb-1 flex items-center gap-x-1">
                                                            <input type="text"
                                                                [value]="customCarrierDraft()"
                                                                (input)="setCustomCarrierDraft($event)"
                                                                placeholder="Custom carrier..."
                                                                class="flex-1 text-xs border border-[var(--border)] rounded-md px-2 py-1.5 bg-input text-primary outline-none focus:border-primary placeholder:text-secondary" />
                                                            <button type="button"
                                                                (click)="saveCustomCarrier(shipment)"
                                                                title="Save custom carrier"
                                                                class="logi-icon-btn logi-icon-btn--accent"
                                                                [disabled]="!customCarrierDraft().trim()">
                                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    }
                                                </div>
                                            </td>

                                            <!-- Tracking code -->
                                            <td class="py-3 pr-4 align-middle">
                                                @if (trackingEditId() === shipment.id) {
                                                <div class="flex items-center gap-x-1">
                                                    <input type="text"
                                                        class="tracking-input"
                                                        [value]="trackingDraft()"
                                                        (input)="setTrackingDraft($event)"
                                                        placeholder="Tracking number..."
                                                        autofocus />
                                                    <button type="button"
                                                        (click)="saveTrackingEdit(shipment)"
                                                        title="Save"
                                                        class="logi-icon-btn logi-icon-btn--accent"
                                                        [disabled]="!trackingDraft().trim()">
                                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
                                                    </button>
                                                    <button type="button"
                                                        (click)="closeTrackingEdit()"
                                                        title="Cancel"
                                                        class="logi-icon-btn logi-icon-btn--muted">
                                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>
                                                    </button>
                                                </div>
                                                } @else if (shipment.trackingNumber) {
                                                <div class="flex items-center gap-x-1">
                                                    <button type="button"
                                                        class="tracking-btn"
                                                        [class.copied]="copiedId() === shipment.id"
                                                        (click)="copyTracking(shipment)"
                                                        title="Click to copy">
                                                        <p class="m-0">{{ shipment.trackingNumber }}</p>
                                                        <span class="tracking-copy-icon" aria-hidden="true">
                                                            @if (copiedId() === shipment.id) {
                                                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
                                                            } @else {
                                                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/></svg>
                                                            }
                                                        </span>
                                                    </button>
                                                    @if (shipment.trackingLink) {
                                                    <a [href]="shipment.trackingLink"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        class="logi-icon-btn logi-icon-btn--muted"
                                                        title="Open tracking page"
                                                        [attr.aria-label]="'Open tracking page for ' + shipment.trackingNumber">
                                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 3h6v6"/><path d="M10 14 21 3"/><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/></svg>
                                                    </a>
                                                    }
                                                </div>
                                                } @else {
                                                <button type="button"
                                                    class="tracking-empty"
                                                    (click)="openTrackingEdit(shipment)">
                                                    Not yet assigned
                                                </button>
                                                }
                                            </td>

                                            <!-- Dates -->
                                            <td class="py-3 pr-3 align-middle">
                                                <div class="flex flex-col gap-y-0.5 text-xs text-secondary">
                                                    @if (shipment.shippedAt) {
                                                    <span>Shipped: {{ shipment.shippedAt | date:'dd MMM yy' }}</span>
                                                    }
                                                    @if (shipment.deliveredAt) {
                                                    <span class="text-success">Delivered: {{ shipment.deliveredAt | date:'dd MMM yy' }}</span>
                                                    }
                                                    @if (!shipment.shippedAt && !shipment.deliveredAt) {
                                                    <span class="text-secondary italic">—</span>
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }

    </div>
    <!-- Main Content - END -->

    <!-- Footer -->
    <div class="flex-0 flex flex-row items-center justify-between w-full border-t border-zinc-200 dark:border-zinc-800 pt-2">
        @if (!isLoading() && shipments().length > 0) {
        <p class="text-xs text-secondary">
            Showing <strong class="text-primary">{{ displayedShipments().length }}</strong>
            of <strong class="text-primary">{{ shipments().length }}</strong> shipment{{ shipments().length === 1 ? '' : 's' }}
        </p>
        }
    </div>
    <!-- Footer - END -->
    }
    }
</div>
